import React, { useEffect, useState } from 'react';
import WhiteCard from '../../../../components/accountCards/WhiteCard';
import { CreateMT5AccountTypeApi, GetAllAccountTypeApi } from '../../../../api/request/account';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Form, Select, Spin } from 'antd';
import toast from 'react-hot-toast';
import ModalComponent from '../../../../components/modals/ModalComponent.jsx';
import ConfirmationModal from '../../../../components/modals/ConfirmationModal.jsx';
import Copy from '../../../../components/copy/Copy.jsx';
import { handleApiError } from '../../../../utils/handleApiError.js';
import LoadableButton from '../../../../components/buttons/LoadableButton.jsx';

export default function AccountTypes() {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { userDetails } = useSelector(state => state.user);
    const [searchParams] = useSearchParams();
    const [accountTypes, setAccountTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState(false);
    const [createdDemoAccount, setCreatedDemoAccount] = useState(null);
    const [isOpenCreateConfirm, setIsOpenCreateConfirm] = useState(false);
    const [accountCreateType, setAccountCreateType] = useState('');
    const [isOpenDemoForm, setIsOpenDemoForm] = useState(false);
    const [isOpenDemoAccountSuccess, setIsOpenDemoAccountSuccess] = useState(false);
    const [isLiveFormLoading, setIsLiveFormLoading] = useState(false);
    const [isDemoFormLoading, setIsDemoFormLoading] = useState(false);

    const depositOptions = [
        { value: 1000, label: '1000' },
        { value: 3000, label: '3000' },
        { value: 5000, label: '5000' },
        { value: 50000, label: '50000' },
        { value: 100000, label: '100000' }
    ];


    const copyText = (text) => {
        navigator.clipboard.writeText(text);
    }

    const getAcounts = async () => {
        try {
            setIsLoading(true);
            let params = {
                UserId: userDetails?._id,
                AccountType: searchParams?.get('type') == 'live' ? true : "demoaccount"
            }
            const { data } = await GetAllAccountTypeApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setAccountTypes(data?.data?.filter((item) => item?.isActive));
            }
            setIsLoading(false);
        } catch (error) { }
    }

    useEffect(() => {
        getAcounts();
    }, []);

    useEffect(() => {
        if (isOpenDemoForm) {
            form.resetFields();
        }
    }, [form, isOpenDemoForm]);

    const createAccount = (account) => {
        setSelectedAccount(account);
        if (searchParams?.get('type') == 'live') {
            setAccountCreateType('live');
            setIsOpenCreateConfirm(true);
            return;
        }
        if (searchParams?.get('type') == 'demo') {
            setIsOpenDemoForm(true);
            return;
        }
    }

    const handleConfirmCreateAccount = () => {
        if (!accountCreateType) return;
        createMT5Account(accountCreateType);
    };

    const handleDemoAccount = (values) => {
        createMT5Account('demo', values?.depositAmount);
    };

    const createMT5Account = async (ACtype, depositAmount = 0) => {
        const isDemo = ACtype === "demo";
        try {
            if (isDemo) {
                setIsDemoFormLoading(true);
            } else {
                setIsLiveFormLoading(true);
            }
            let params = {
                depositAmount,
                groupId: selectedAccount?.groupId,
                groupName: selectedAccount?.groupName,
                isDemoAccount: isDemo,
                isLiveAccount: !isDemo,
                leverage: selectedAccount?.leverage,
                planId: selectedAccount?.planId,
                userId: userDetails?._id
            }
            const { data } = await CreateMT5AccountTypeApi(params);
            if (data?.success) {
                toast?.success(data?.message);
                if (isDemo) {
                    setCreatedDemoAccount(data?.data);
                    setIsOpenDemoForm(false);
                    setIsOpenCreateConfirm(false);
                    setIsOpenDemoAccountSuccess(true);
                } else {
                    setIsOpenCreateConfirm(false);
                    navigate("/accounts?filter=Live+Account");
                }
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            if (isDemo) {
                setIsDemoFormLoading(false);
            } else {
                setIsLiveFormLoading(false);
            }
        }
    }

    const goToDashboard = () => {
        setIsOpenDemoAccountSuccess(false);
        navigate('/dashboard');
    }

    return (
        <div className='min-h-[calc(100vh-145px)]'>
            {isLoading ? (
                <div className="flex justify-center flex-col my-[20%]">
                    <Spin size="large" />
                    <p className="primary text-center mt-2">Loading...</p>
                </div>
            ) : (
                <div className='h-full min-h-[calc(100vh-145px)] flex items-center justify-center'>
                    {(userDetails?.kycStatus !== 'Approved' && searchParams?.get('type') === 'live') ? (<div className='flex flex-col items-center justify-center gap-6'>
                        <h2 className="text-2xl font-semibold primary">Complete Your KYC</h2>
                        <p className="text-gray-500 text-lg">
                            To open a live account, please complete your KYC verification.
                        </p>
                        <button onClick={() => navigate("/kyc")} className=" px-6 py-1.5 bg-primary text-white rounded-lg"  >
                            Proceed to KYC
                        </button>
                    </div>) :
                        (accountTypes?.length ? (
                            <div className='flex flex-wrap items-center justify-center gap-5 sm:mx-10'>
                                {accountTypes?.map((account, index) => (
                                    <WhiteCard index={index + 1} account={account} handleSubmit={createAccount} type={searchParams?.get('type')} />
                                ))}
                            </div>
                        ) : (<p className='text-lg text-gray-500'>No accounts found.</p>)
                        )}
                </div>
            )}

            <ConfirmationModal
                isOpen={isOpenCreateConfirm}
                setIsOpen={setIsOpenCreateConfirm}
                type='success'
                message='Are you sure you want to create the account?'
                onConfirm={handleConfirmCreateAccount}
                isLoading={isLiveFormLoading}
                loadingLabel={accountCreateType === 'live' ? 'Opening Live Account...' : 'Opening Demo Account...'}
            />

            <ModalComponent isOpen={isOpenDemoForm} setIsOpen={setIsOpenDemoForm} title='Open Demo Account'>
                <div className='mb-3'>
                    <p>Please select the deposit amount for your demo account.</p>
                </div>
                <Form className='w-full' autoComplete="off" form={form} onFinish={handleDemoAccount}>
                    <div className='ant-select-selector-white'>
                        <Form.Item name='depositAmount' rules={[{ required: true, message: 'Please select deposit.' }]}>
                            <Select className='border-[#193CB838] w-full mt-1' placeholder='Select deposit' options={depositOptions} />
                        </Form.Item>
                    </div>
                    <div className='flex justify-end items-center gap-5 mt-10'>
                        <button
                            type='button'
                            disabled={isDemoFormLoading}
                            className='text-sm white primary font-bold uppercase px-8 py-3 rounded-lg border border-[#193CB838] duration-500'
                            onClick={() => setIsOpenDemoForm(false)}
                        >
                            Cancel
                        </button>
                        <LoadableButton
                            className='bg-[#193CB8] hover:bg-[#193CB8] text-sm text-white font-semibold rounded-lg px-12 py-3 uppercase'
                            disabled={isDemoFormLoading}
                            type="Submit"
                            lable='Proceed'
                            isLoading={isDemoFormLoading}
                            loadingLable='Opening Demo Account...'
                        />
                    </div>
                </Form>
            </ModalComponent>

            {/* Demo account success modal */}
            <ModalComponent isOpen={isOpenDemoAccountSuccess} setIsOpen={setIsOpenDemoAccountSuccess} title='Congratulations!, Demo Account Created!'>
                <p className='primary md:text-lg font-semibold'>{userDetails?.fullName} you have Successfully Open MT5 Account with UpForex.</p>
                <div>
                    <div className='flex justify-between items-center mt-8 border-y py-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Account No.</p></div>
                        <div className='flex justify-center items-center'>
                            <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.accountNo}</p>
                            <Copy text={createdDemoAccount?.accountNo}></Copy>
                        </div>
                    </div>
                    <div className='flex justify-between items-center mt-2 border-b pb-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Server Name</p></div>
                        <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.serverName}</p>
                    </div>
                    <div className='flex justify-between items-center mt-2 border-b pb-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Master Password</p></div>
                        <div className='flex justify-center items-center'>
                            <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.master_password}</p>
                            <Copy text={createdDemoAccount?.master_password}></Copy>
                        </div>
                    </div>
                    <div className='flex justify-between items-center mt-2 border-b pb-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Investor Password</p></div>
                        <div className='flex justify-center items-center'>
                            <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.investor_password}</p>
                            <Copy text={createdDemoAccount?.investor_password}></Copy>
                        </div>
                    </div>
                </div>
                <div className='mt-8 flex justify-center items-center'>
                    <button className='bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500' onClick={goToDashboard}>Go To Dashboard</button>
                </div>
            </ModalComponent >

        </div >
    )
}
